import { useAuthentificationStore } from "@/features/auth/authentification/stores/useAuthentificationStore"
import type { Fetch } from '@/features/fetch/types'
import type { IDialog } from "@/features/interface/dialog/types"
import { useDialog } from "@/features/interface/dialog/useDialog"
import { SilentError } from "@/features/shared/types"

export class BlocageImpersoError extends SilentError { }
export function configBlocageImperso(nextFetch: Fetch): Fetch {
  const auth = useAuthentificationStore()



  return function (input: RequestInfo | URL, init?: RequestInit) {
    if (init?.blocageImpersoDisabled)
      return nextFetch(input, init)

    const method = (input instanceof Request ? input.method : undefined) ?? init?.method ?? 'GET'
    if (method === "GET")
      return nextFetch(input, init)

    if (auth.utilisateur?.estInterne) {
      const dialog: IDialog = useDialog()

      dialog.showDialog({
        type: 'Error',
        title: 'Information',
        message: ["Les modifications ne sont pas autorisées pour les collaborateurs AKTO."],
      })

      throw new BlocageImpersoError()
    }


    return nextFetch(input, init)
  }
}
